__turbopack_context__.v({
  "errorIcon": "oEiDTq_errorIcon" + " " + "oEiDTq_roundedIcon",
  "infoIcon": "oEiDTq_infoIcon" + " " + "oEiDTq_roundedIcon",
  "roundedIcon": "oEiDTq_roundedIcon",
  "successIcon": "oEiDTq_successIcon" + " " + "oEiDTq_roundedIcon",
  "warningIcon": "oEiDTq_warningIcon" + " " + "oEiDTq_roundedIcon",
});
